import { FC, SyntheticEvent, useContext, useEffect, useState } from "react";

import { ProcedureContext } from "@/context/ProcedureContext";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import CloseIcon from "@mui/icons-material/Close";
import ListIcon from "@mui/icons-material/List";
import {
	Box,
	Dialog,
	DialogContent,
	DialogTitle,
	Divider,
	FormControl,
	Grid,
	IconButton,
	InputLabel,
	MenuItem,
	Select,
	Tab,
	Tabs,
  Typography,
} from "@mui/material";

import { Translate } from "@/components/Application/Translate";
import ManualChecklistForm from "@/components/Procedures/NewChecklist/ManualChecklistForm";
import NewWizardChecklistForm from "@/components/Procedures/NewChecklist/NewWizardChecklistForm";

import { ProcedureDetailNode } from "@/model/Procedure/ProcedureDetailNode";

import { useFetchActiveProcedureDetails } from "@/service/ProcedureQueries";

interface NewChecklistModalProps {
	open: boolean;
	onClose: () => void;
  selectedNode?: ProcedureDetailNode;
}

const NewChecklistModal: FC<NewChecklistModalProps> = ({ open, onClose, selectedNode }) => {
	const [currentTab, setTab] = useState<number>(1);
	const [selectedGroup, setSelectedGroup] = useState<
		ProcedureDetailNode | undefined
	>();

	const { data: procedureDetails } = useFetchActiveProcedureDetails();
	const { activeChecklistId, setActiveChecklistId } =
		useContext(ProcedureContext);

	useEffect(() => {
		setSelectedGroup(selectedNode);
	}, [selectedNode]);

	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
			<DialogTitle sx={{ fontSize: "1.25rem", fontWeight: 500 }}>
				<Translate String="Procedure.Checklist.New">New Checklist</Translate>
        <Typography
          variant="subtitle2"
          sx={{
            fontSize: "0.8rem",
            fontWeight: 400,
            color: (theme) => theme.palette.text.secondary,
            marginTop: "0.5rem",
          }}
        >
            {selectedGroup?.Name}
        </Typography>
				<IconButton
					aria-label="close"
					onClick={onClose}
					sx={{
						position: "absolute",
						right: 8,
						top: 8,
					}}
				>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<br />
			<DialogContent sx={{ p: 2 }} dividers>

				<NewWizardChecklistForm
					onClose={onClose}
					selectedGroup={selectedGroup}
					setActiveSchemeId={setActiveChecklistId}
				/>
			</DialogContent>
		</Dialog>
	);
};

export default NewChecklistModal;
